export const STATUS = {
  beklemede: { label: "Beklemede", badge: "bg-amber-100 text-amber-900 border-amber-300", dot: "bg-amber-500" },
  onaylandi: { label: "Onaylandı", badge: "bg-emerald-100 text-emerald-900 border-emerald-300", dot: "bg-emerald-500" },
  ertelendi: { label: "Ertelendi", badge: "bg-sky-100 text-sky-900 border-sky-300", dot: "bg-sky-500" },
  iptal: { label: "İptal", badge: "bg-rose-100 text-rose-900 border-rose-300", dot: "bg-rose-500" },
  gelmedi: { label: "Gelmedi", badge: "bg-slate-200 text-slate-800 border-slate-300", dot: "bg-slate-500" },
};
export const STATUS_KEYS = Object.keys(STATUS);

export const WEEKDAYS = ["Pazartesi", "Salı", "Çarşamba", "Perşembe", "Cuma", "Cumartesi", "Pazar"];

const pad = (n) => String(n).padStart(2, "0");

export const todayTR = () => new Intl.DateTimeFormat("en-CA", { timeZone: "Europe/Istanbul" }).format(new Date());
export const toISO = (d) => `${d.getFullYear()}-${pad(d.getMonth() + 1)}-${pad(d.getDate())}`;
export const fromISO = (s) => {
  const [y, m, d] = s.split("-").map(Number);
  return new Date(y, m - 1, d);
};
export const addDays = (s, n) => {
  const d = fromISO(s);
  d.setDate(d.getDate() + n);
  return toISO(d);
};
export const mondayOf = (s) => addDays(s, -((fromISO(s).getDay() + 6) % 7));
export const backendWeekday = (d) => (d.getDay() + 6) % 7;

export const fmtDate = (s, opts = { day: "numeric", month: "long", year: "numeric", weekday: "long" }) =>
  s ? fromISO(s).toLocaleDateString("tr-TR", opts) : "";

export const fmtPhone = (p) => {
  const d = (p || "").replace(/\D/g, "");
  if (d.length !== 12) return p || "";
  return `+${d.slice(0, 2)} ${d.slice(2, 5)} ${d.slice(5, 8)} ${d.slice(8, 10)} ${d.slice(10)}`;
};

export const waLink = (number, text = "") =>
  `https://wa.me/${(number || "").replace(/\D/g, "")}${text ? `?text=${encodeURIComponent(text)}` : ""}`;

export function waTemplate(a, academy = "Masal Sanat Akademi") {
  const when = `${fmtDate(a.date, { day: "numeric", month: "long", weekday: "long" })} saat ${a.time}`;
  const hi = `Merhaba ${a.name},`;
  const map = {
    beklemede: `${hi} ${academy}'den yazıyoruz. ${a.course_name} için ${when} tanışma dersi talebinizi (${a.request_no}) aldık. Kısa süre içinde onaylayacağız.`,
    onaylandi: `${hi} ${academy}'den yazıyoruz. ${a.course_name} tanışma dersiniz ${when} olarak onaylandı. Görüşmek üzere!`,
    ertelendi: `${hi} ${academy}'den yazıyoruz. ${a.course_name} tanışma dersinizi ${when} olarak güncelledik. Uygun değilse lütfen bize yazın.`,
    iptal: `${hi} ${academy}'den yazıyoruz. ${a.request_no} numaralı tanışma dersi talebiniz iptal edildi. Yeni bir zaman için bize yazabilirsiniz.`,
    gelmedi: `${hi} ${academy}'den yazıyoruz. ${when} tanışma dersinde sizi göremedik. Yeni bir randevu oluşturmak ister misiniz?`,
  };
  return map[a.status] || map.beklemede;
}
